import { SubmitBookingFormData } from 'src/components/checkout/SectionCheckout';
import { action } from 'src/store/actions';

export const FETCH_EXPERTISE = 'FETCH_EXPERTISE';
export const REQUEST_EXPERTISE = 'REQUEST_EXPERTISE';
export const SUCCESS_EXPERTISE = 'SUCCESS_EXPERTISE';
export const FAILURE_EXPERTISE = 'FAILURE_EXPERTISE';
export const FETCH_SEND_REPAIR_OFFER = 'FETCH_SEND_REPAIR_OFFER';
export const FAILURE_SEND_REPAIR_OFFER = 'FAILURE_SEND_REPAIR_OFFER';

export const fetchExpertise = () => action(FETCH_EXPERTISE);
export const requestExpertise = () => action(REQUEST_EXPERTISE);
export const requestExpertiseSuccess = (response: any) => action(SUCCESS_EXPERTISE, { response });
export const requestExpertiseFailure = (error: any) => action(FAILURE_EXPERTISE, { error });
export const fetchSendRepairOffer = (data: SubmitBookingFormData) => action(FETCH_SEND_REPAIR_OFFER, { data });
export const requestSendOfferFailure = (error: any) => action(FAILURE_EXPERTISE, { error });
